import {
	createPublicClient,
	http,
	type defineChain,
	type PublicClient,
} from "viem";

import {
	chains,
} from "./const";


import { getRPCURL, } from "@bracket/chainography";


import type { HTTPURL, RuntimeMode, } from "@types";
import type { ValidChainId, } from "@bracket/types";

import type { Config, } from "@wagmi/core";


export declare type GetViemClientProps = {
	chainId?: ValidChainId;
	mode?: RuntimeMode;
	url?: HTTPURL;
	admin?: boolean;
	chain?: ReturnType<typeof defineChain>;
	config?: Config;
}


export const getViemClient = ({
	url,
	admin = false,
	chainId = 1,
	chain,
	config,
}: GetViemClientProps = {}): PublicClient => {
	url = url || getRPCURL(chainId);
	chain = chain || chains.get(chainId);
	if(url && chain) {
		//@ts-ignore - Viem's horrible typing produces :  instantiation is excessively deep
		return createPublicClient({ chain, transport: http(url), });
	}
	throw new Error("@bracket/contractor::getViemClient failed producing a valid client");
}
